import React from 'react';
// import { useNavigate } from 'react-router-dom';
import { LogOut, User, Lock, Bell, Shield, Mail } from 'lucide-react';
import {Navbar} from '../Dashboard/DashboarEntreprise/Navbar';
import Sidebar from '../Dashboard/DashboarEntreprise/Sidebar';
import { useAdminInfo } from '../../pages/Dashboard/DashboarEntreprise/hooksUseretApplication/hookAdmin Info';
import { initiateLogOut } from '../../../vitrine/services/OauthUtils';

const Settings: React.FC = () => {
  // const navigate = useNavigate();
  const { adminInfo } = useAdminInfo();
console.log('company',adminInfo)
  

  const sectionClass = "bg-white shadow-sm border border-gray-100 rounded-xl p-6 mb-8 transition-all duration-300 hover:shadow-md";
  const sectionTitleClass = "text-xl font-semibold text-gray-800 mb-4 flex items-center";
  const buttonClass = "mt-4 px-4 py-2 text-sm font-medium text-white bg-slate-700 rounded-md hover:bg-slate-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-slate-500 transition-colors";

  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar />
      <div className="flex pt-20">
        <div className="w-full md:w-1/4 lg:w-1/5 bg-white shadow-md min-h-screen">
          <Sidebar />
        </div>
        <div className="w-full md:w-3/4 lg:w-4/5 p-6 md:p-10 space-y-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-8">General Settings</h1>

          {/* Company Profile */}
          <div className="bg-white shadow-sm border border-gray-100 rounded-2xl p-6 mb-8 transition-all duration-300 hover:shadow-md hover:scale-[1.01]">
  <h2 className="text-xl font-semibold text-gray-800 mb-6 flex items-center">
    <User className="mr-2 text-indigo-600" /> Company Profile
  </h2>

  <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 text-sm text-gray-700">
    <div>
      <p className="font-medium text-gray-900">Company Name</p>
      <p className="text-gray-600">{adminInfo?.companyName || 'Company Name'}</p>
    </div>

    <div>
      <p className="font-medium text-gray-900">Admin Name</p>
      <p className="text-gray-600">{adminInfo?.fullName || 'Admin'}</p>
    </div>

    <div>
      <p className="font-medium text-gray-900">Email</p>
      <p className="text-gray-600">{adminInfo?.email || 'admin@mail.com'}</p>
    </div>

    <div>
      <p className="font-medium text-gray-900">Subscription Start</p>
      <span className="inline-block bg-blue-50 text-blue-700 px-2 py-0.5 rounded text-xs shadow-sm">
        {adminInfo?.subscriptionStartDate || 'Start Date'}
      </span>
    </div>

    <div>
      <p className="font-medium text-gray-900">Subscription End</p>
      <span className="inline-block bg-red-50 text-red-600 px-2 py-0.5 rounded text-xs shadow-sm">
        {adminInfo?.subscriptionEndDate || 'End Date'}
      </span>
    </div>
  </div>

  <div className="mt-6">
    <button className="px-4 py-2 text-sm font-medium text-white bg-slate-700 rounded-md hover:bg-slate-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-slate-500 transition-colors">
      Update Profile
    </button>
  </div>
</div>


          {/* Security */}
          <div className={sectionClass}>
            <h2 className={sectionTitleClass}><Lock className="mr-2" /> Security</h2>
            <button className={buttonClass}>Change Password</button>
          </div>

          {/* Notifications */}
          <div className={sectionClass}>
            <h2 className={sectionTitleClass}><Bell className="mr-2" /> Notifications</h2>
            <div className="space-y-4">
              <div className="flex items-center">
                <input type="checkbox" id="email-notifications" defaultChecked className="h-4 w-4 text-indigo-600 border-gray-300 rounded focus:ring-indigo-500" />
                <label htmlFor="email-notifications" className="ml-2 text-sm text-gray-700">Receive email notifications</label>
              </div>
              <div className="flex items-center">
                <input type="checkbox" id="push-notifications" defaultChecked className="h-4 w-4 text-indigo-600 border-gray-300 rounded focus:ring-indigo-500" />
                <label htmlFor="push-notifications" className="ml-2 text-sm text-gray-700">Receive push notifications</label>
              </div>
              <button className={buttonClass}>Save Preferences</button>
            </div>
          </div>

          {/* Privacy */}
          <div className={sectionClass}>
            <h2 className={sectionTitleClass}><Shield className="mr-2" /> Privacy</h2>
            <div className="space-y-4">
              <div className="flex items-center">
                <input type="checkbox" id="data-sharing" className="h-4 w-4 text-indigo-600 border-gray-300 rounded focus:ring-indigo-500" />
                <label htmlFor="data-sharing" className="ml-2 text-sm text-gray-700">Allow anonymous data sharing</label>
              </div>
              <div className="flex items-center">
                <input type="checkbox" id="cookies" defaultChecked className="h-4 w-4 text-indigo-600 border-gray-300 rounded focus:ring-indigo-500" />
                <label htmlFor="cookies" className="ml-2 text-sm text-gray-700">Accept cookies</label>
              </div>
              <button className={buttonClass}>Save Preferences</button>
            </div>
          </div>

          {/* Contact */}
          <div className={sectionClass}>
            <h2 className={sectionTitleClass}><Mail className="mr-2" /> Contact</h2>
            <p className="text-sm text-gray-700 mb-2">For any questions or support, contact us at:</p>
            <a href="mailto:support@example.com" className="text-indigo-600 hover:text-indigo-900 text-sm">support@example.com</a>
          </div>

          {/* Logout */}
          <div className={sectionClass}>
            <button onClick={initiateLogOut} className="w-full px-4 py-2 text-sm font-medium text-white bg-red-600 rounded-md hover:bg-red-700 flex items-center justify-center">
              <LogOut className="mr-2" /> Log Out
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Settings;
